import { Component, Input, Output, OnInit, OnChanges, OnDestroy, SimpleChanges, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { EquipmentService } from '../../../services/equipment.service';
import { HaloLoaderService } from '../../../../core/halo-loader/halo-loader.service';
import { cardioAsset, equipmentDetailsObject, INameAllEquipmentData, nonCardioEquipmentBaseObject, nonCardioEquipmentDetails } from 'src/app/post-login/services/equipment.model';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { Router } from '@angular/router';
import { FacilityService } from 'src/app/core/services/facility.service';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit {
  originalList: equipmentDetailsObject[];
  list: equipmentDetailsObject[];

  originalNonCardioEquipmentList: nonCardioEquipmentDetails[];
  listNonCardioEquipment: nonCardioEquipmentDetails[];

  currentFacility: FacilityObject;
  rootScopeData: RootScopeDeclare;
  private sub = new Subscription()
  private _isMobile: boolean = true;
  _showProductModal: boolean = false;
  _showDeleteModal: boolean = false;
  _selectedAssetId: number;
  _assetDeletionIndex: number;
  _productPageUrl: string;
  // mobile
  selectedEquipment: equipmentDetailsObject | any;
  selectedNonCardioEquipment: nonCardioEquipmentDetails | any;
  allEquipmentCount: number = 0;
  consoleListDropdownVisibility: boolean = false;
  assetForCardioEquipmentDeletion: cardioAsset;
  assetForNonCardioEquipmentDeletion: nonCardioEquipmentBaseObject;
  typeOfDeletion: string = 'cardio' ||'strength' || 'smartInfra';
  notConnectedStatusMessage: string;
  savedDeleteAssetData: any;

  deleteModalProps = {
    title: 'DELETE',
    message: 'DELETE.EQUIPMENT.DISCONNECTED.MSG',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
    hideSecondaryButton: true,
  };

  // name all
  showActionBtns: boolean = false;
  isNameModified: boolean = false;
  toggleOpenedIndex: number;
  isNonCardioEquipmentOpened = false;
  showUnsavedModal: boolean = false;

  @ViewChild('viewContainer') viewContainer: ElementRef;

  @Output() callParent: EventEmitter<string> = new EventEmitter();

  @Input() set equipments(items: equipmentDetailsObject[]) {
    this.originalList = JSON.parse(JSON.stringify(items));
    this.list = items;

    // mobile
    if (items && items.length > 0) {
      items.forEach((e) => {
        this.allEquipmentCount = this.allEquipmentCount + (e.assetDetails ? e.assetDetails.length : 0);

        if (items.length === 1) {
          e.isOpen = true;
        }
      });
    }
  }

  @Input() set nonCardioEquipments(items: nonCardioEquipmentDetails[]) {
    this.originalNonCardioEquipmentList = JSON.parse(JSON.stringify(items));
    // mobile
    if (items && items.length > 0) {
      items.forEach((e) => {
        this.allEquipmentCount = this.allEquipmentCount + (e.nonCardioAssetDetailsObject ? e.nonCardioAssetDetailsObject.length : 0);
      });
    }
    this.listNonCardioEquipment = items;
  }

  @Input() set isMobile(val: boolean) {
    this._isMobile = val;
  }

  @Input() facilityId: string;
  @Input() hasFullPermission: boolean;

  get isMobile(): boolean {
    return this._isMobile;
  }

  constructor(
    public commonUtil: CommonUtil,
    private rootScopeService: RootScopeService,
    private facilityService: FacilityService,
    private multiFacService: MultiFacilityService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _equipmentService: EquipmentService,
    private _loader: HaloLoaderService,
    private _toast: HaloToastService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.getRootScopeData();
    if (this.isMobile) {
      this.initMobile();
    }
    let _tlink = ` <a target="_blank" href="https://halofitness.zendesk.com/hc/en-us/articles/360060364271-Connect-Equipment-to-Internet">
        ${this.commonUtil.translateText('TROUBLESHOOT')}</a>.`;
    this.notConnectedStatusMessage = this.commonUtil.translateText('EQUIPMENT.NOT.CONNECTED') + _tlink;
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes.facilityId && changes.facilityId.currentValue && changes.facilityId.currentValue !== changes.facilityId.previousValue){
      this.showActionBtns = false;
      this.isNameModified = false;
    }
  }

  initMobile() {}

  getRootScopeData(): void {
    const rootScopeServiceSub = this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
    this.sub.add(rootScopeServiceSub);
  }

  toggleOpen(i: number) {
    if (this.list.length > 0 && !this.isNameModified) {
      this.listNonCardioEquipment.map(item => item.isOpen = false);
      this.toggleOpenedIndex = i;
      this.list.map((item, index) => {
        if (index === i) {
          item.isOpen = !item.isOpen;
        } else {
          item.isOpen = false;
        }
      });
      this.isNonCardioEquipmentOpened = false;
      this.viewContainer.nativeElement.scrollIntoView({ behavior: 'smooth' });

      // cancel changes
      // todo: if modified need to show alert isNameModified
      if (this.isNameModified) {
        this.nameAllCancel();
      }
    }
  }

  toggleOpenForNonCardioEquipment(i: number) {
    if (this.listNonCardioEquipment.length > 0 && !this.isNameModified) {
      this.list.map(item => item.isOpen = false);
      this.toggleOpenedIndex = i;
      this.listNonCardioEquipment.map((item, index) => {
        if (index === i) {
          item.isOpen = !item.isOpen;
        } else {
          item.isOpen = false;
        }
      });
      this.isNonCardioEquipmentOpened = true;
      this.viewContainer.nativeElement.scrollIntoView({ behavior: 'smooth' });

      // cancel changes
      // todo: if modified need to show alert isNameModified
      if (this.isNameModified) {
        this.nameAllCancel();
      }
    }
  }

  resetOpenedEquipmentList(){
   if(!this.isNameModified) {
    this.list.map((item, index) => {
      item.isOpen = false;
    });
      this.listNonCardioEquipment.map((item, index) => {
        item.isOpen = false;
      });
   }
  }

  loadProductPage(): void {
    this._loader.startProcess();
    const getProductUrlSub = this._equipmentService.getProductUrl(this._selectedAssetId).subscribe(
      (data: { productPageUrl: string }) => {
        this._productPageUrl = data.productPageUrl + '&source=facility';
        this._showProductModal = true;
        this._loader.endProcess();
      },
      (error) => {
        console.error('API failed.');
        this._loader.endProcess();
      }
    );
    this.sub.add(getProductUrlSub);
  }

  openAsset(asset: cardioAsset) {
    this._selectedAssetId = asset.id;
    this.loadProductPage();
  }

  closeProductModal(): void {
    this._showProductModal = false;
  }

  deleteAsset(asset: any,equipmentType: string, ind: number) {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.savedDeleteAssetData = {
        asset,
        equipmentType,
        ind
      }
      this.openUnsavedModal();
      return
    }
    this.confirmDeleteAsset(asset, equipmentType, ind)
  }

  confirmDeleteAsset(asset: any,equipmentType: string, ind: number): void {
    asset.isOnline = asset.isOnline?asset.isOnline:asset.isConnected;
    this._showDeleteModal = true;
    this.typeOfDeletion = equipmentType;
    if(equipmentType === 'strength' || equipmentType === 'smartInfra'){
      this.assetForNonCardioEquipmentDeletion = asset;
    }else{
      this.assetForCardioEquipmentDeletion = asset;
    }
    
    this._assetDeletionIndex = ind;
    this.deleteModalProps.title = this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.DELETE.TITLE', [
      this.commonUtil.translateText('EQUIPMENT'),
    ]);
    if (asset['isOnline'] && asset.isOnline.toString() === 'true') {
      this.deleteModalProps.message = 'DELETE.EQUIPMENT.CONNECTED.MSG';
      this.deleteModalProps.ctaButtonLabel = 'OK';
      this.deleteModalProps.isCloseIconCallsCta = false;
      this.deleteModalProps.isSecondaryTextButton = false;
      this.deleteModalProps.hideSecondaryButton = true;
    } else {
      this.deleteModalProps.message = 'DELETE.EQUIPMENT.DISCONNECTED.MSG';
      this.deleteModalProps.ctaButtonLabel = 'DELETE';
      this.deleteModalProps.negativeButtonLabel = 'CANCEL';
      this.deleteModalProps.isCloseIconCallsCta = false;
      this.deleteModalProps.isSecondaryTextButton = true;
      this.deleteModalProps.hideSecondaryButton = false;
    }
    this.showActionBtns = false;
    this.isNameModified = false;
  }

  deleteEquipmentConfirmed(): void {
    if(this.typeOfDeletion === 'cardio'){
      this.deleteCardioEquipment();
    }else if(this.typeOfDeletion === 'strength'){
      this.deleteNonCardioEquipment();
    }else{
      this._loader.endProcess();
      this.closeDeleteModal();
    }
  }

  async deleteCardioEquipment(){
    if (!this.assetForCardioEquipmentDeletion['isOnline'] || this.assetForCardioEquipmentDeletion.isOnline.toString() === 'false') {   
      const bodyserial = this.assetForCardioEquipmentDeletion.bodySerial?
      this.assetForCardioEquipmentDeletion.bodySerial:
      this.assetForCardioEquipmentDeletion.displayBodySerial as string;
      this._amplitudeAnalytics.logEvent({elementName: 'Delete', action: 'Submit', additionalProperty: {bodySerial: bodyserial}});
      try {
        await this.deleteEquipment(this.assetForCardioEquipmentDeletion.facilityId.toString(),
          bodyserial, String(this.assetForCardioEquipmentDeletion.id));
        this.removeCardioEquipmentFromList();
      } catch (error) {
        console.error('API failed.');
      }      
    } else {
      this.closeDeleteModal();
    }
  }


  async deleteNonCardioEquipment(){
    if (this.assetForNonCardioEquipmentDeletion['isConnected'].toString() === 'false') {      
      this._amplitudeAnalytics.logEvent({elementName: 'Delete', action: 'Submit', additionalProperty: {serialNum: this.assetForNonCardioEquipmentDeletion.equipmentSerialNumber}});
      try {        
        await this.deleteEquipment(this.assetForNonCardioEquipmentDeletion.facilityId.toString(), this.assetForNonCardioEquipmentDeletion.equipmentSerialNumber,this.assetForNonCardioEquipmentDeletion.assetId);
        this.removeNonCardioEquipmentFromList();
      } catch (error) {
        console.error('API failed.');
      }
    } else {
      this.closeDeleteModal();
    }
  }

  async deleteEquipment(facilityId: string, serial: string,assetId:string){
    this.closeDeleteModal();
    this._loader.startProcess();
    try {
      await this._equipmentService.deleteEquipment(facilityId, serial, this.typeOfDeletion,assetId).toPromise();
      this._toast.creatToast(this.commonUtil.translateText('DELETED.EQUIPMENTITEM.SUCCESS.MSG'));
      // reset facility list
      this.facilityService.reset();
      await this.facilityService.get();
      this.multiFacService.resetMultiFacilitiesList();
      await this.multiFacService.getMultiFacilities();
      this.facilityService.menu();
    } catch (error) {
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  closeDeleteModal(): void {
    this._showDeleteModal = false;
  }

  removeCardioEquipmentFromList(): void {
    this.list.forEach((item, index) => {
      if (item.activityId === this.assetForCardioEquipmentDeletion.activityId) {
        if (item['assetDetails']) {
          item.assetDetails.splice(this._assetDeletionIndex, 1);
          if (!item.assetDetails.length) {
            this.list.splice(index, 1);
          }
        }
      }
    });
    if (!this.list.length) {
      this.callParent.emit();
    }
  }

  removeNonCardioEquipmentFromList(): void {
    this.listNonCardioEquipment.forEach((item, index) => {
      if (item['nonCardioAssetDetailsObject']) {
        item.nonCardioAssetDetailsObject.splice(this._assetDeletionIndex, 1);
        if (!item.nonCardioAssetDetailsObject.length) {
          this.listNonCardioEquipment.splice(index, 1);
        }
      }
    });
    if (!this.listNonCardioEquipment.length) {
      this.callParent.emit();
    }
  }

  // mobile
  selectConsole(item: equipmentDetailsObject) {
    this.resetOpenedEquipmentList();
    this.consoleListDropdownVisibility = false;
    this.selectedEquipment = item;
    this.listNonCardioEquipment = [];
    this.selectedNonCardioEquipment = null;
    this.filterListBySelectedConsole();
    
    //If selectedItem is All Equipment.
    if(!item){
      this.filterListBySelectedNonCardioEquipmentConsole();
    }
  }

  filterListBySelectedConsole() {
    if (this.selectedEquipment) {
      this.list = JSON.parse(
        JSON.stringify(
          this.originalList.filter((e) => {
            return this.selectedEquipment.activityId == e.activityId;
          })
        )
      );
    } else if(!this.selectedEquipment && !this.selectedNonCardioEquipment) {
      this.list = JSON.parse(
        JSON.stringify(
          this.originalList.filter((e) => {
            return true;
          })
        )
      );
    }
  }

    // mobile
    selectConsoleForNonCardioEquipment(item: nonCardioEquipmentDetails) {
      this.resetOpenedEquipmentList();
      this.consoleListDropdownVisibility = false;
      this.selectedNonCardioEquipment = item;
      this.filterListBySelectedNonCardioEquipmentConsole();
      this.list = [];
      this.selectedEquipment = null;
    }
  
    filterListBySelectedNonCardioEquipmentConsole() {
      if (this.selectedNonCardioEquipment) {
        this.listNonCardioEquipment = JSON.parse(
          JSON.stringify(
              this.originalNonCardioEquipmentList.filter((e) => {
                return this.selectedNonCardioEquipment.activityId == e.activityId;
              })
          )
        );
      }else if(!this.selectedEquipment && !this.selectedNonCardioEquipment) {
      this.listNonCardioEquipment = JSON.parse(
          JSON.stringify(
            this.originalNonCardioEquipmentList.filter((e) => {
              return true;
            })
          )
        );
      }
    } 

  nameAll(equipmentType:any) {
    this.showActionBtns = true;
    this.setNameEditable(true,equipmentType);
  }

  nameOne(asset: cardioAsset) {
    this.showActionBtns = true;
    asset.nameEditable = true;
  }

  setNameEditable(action: boolean,equipmentType?: any) {
    if(action){
      //For Cardio Equipment.
      this.list.map((item, index) => {
        if (item.assetDetails && item.activityId === equipmentType.activityId)
          item.assetDetails.map((ass) => {
            ass.nameEditable = true;
          });
      });
      //For Non Cardio Equipment.
      this.listNonCardioEquipment.map((item, index) => {
        if (item.nonCardioAssetDetailsObject && item.activityId === equipmentType.activityId )
          item.nonCardioAssetDetailsObject.map((ass) => {
            ass.nameEditable = true;
          });
      });
    }
    
    this.setDraftedFlag();
  }

  nameAllCancel() {
    // TODO: show alert for modified field
    this.isNameModified = false;
    this.showActionBtns = false;
    this.setNameEditable(false);

    // reset edited values
    this.filterListBySelectedConsole();
    this.filterListBySelectedNonCardioEquipmentConsole();

    // open prev
    if(!this.isNonCardioEquipmentOpened){
      this.toggleOpen(this.toggleOpenedIndex);
    }else{
      this.toggleOpenForNonCardioEquipment(this.toggleOpenedIndex);
    }
   
    this.rootScopeData.isPageHasUnsavedChanges = false;
  }

  async nameAllUpdate() {
    let updateIncomplete = false;
    let names: INameAllEquipmentData[] = [];
    let bodySerial: string = '';
    this.list.map((item) => {
      if (item.assetDetails)
        item.assetDetails.map((asset) => {
          if (asset.nameEditable) {
            names.push({ id: asset.id,assetId:asset.assetId, name: asset.name?asset.name:'', facilityId: asset.facilityId?asset.facilityId:'',bodySerial : asset.bodySerial,equipmentType: 'cardio',equipmentModel:'' });
            bodySerial = asset.bodySerial;
          }
        });
    });

    this.listNonCardioEquipment.map((item) => {
      if (item.nonCardioAssetDetailsObject)
        item.nonCardioAssetDetailsObject.map((asset) => {
          if (asset.nameEditable) {
            names.push({ id: asset.equipmentSerialNumber,assetId:asset.assetId, name: asset.nickName?asset.nickName:'', facilityId: asset.facilityId?asset.facilityId.toString():'',bodySerial : asset.equipmentSerialNumber,equipmentType: item.equipmentType,equipmentModel:asset.equipmentModel  });
            bodySerial = asset.equipmentSerialNumber;
          }
        });
    });

    // single name edit
    if (names.length == 1 && bodySerial != '') {
      this._loader.startProcess();
      this._amplitudeAnalytics.logEvent({elementName: 'Update Name', action: 'Submit'});
      const nameEquipmentSub = this._equipmentService.nameEquipment(names[0].facilityId, bodySerial, names[0].name,names[0].equipmentType, names[0].equipmentModel,names[0].assetId,String(names[0].id)).subscribe(
        (res) => {
          this.nameAllUpdateSuccess(names);
          this._loader.endProcess();
          this._toast.creatToast(this.commonUtil.translateText('UPDATED.EQUIPMENT'));
        },
        (error) => {
          let errorCode;
          let errorMessage = error?.error;
          if(typeof errorMessage !== 'object'){
            errorCode = errorMessage.substring(
              errorMessage.indexOf('Code: ') + 6,
              errorMessage.indexOf('Code: ') + 9
            );
          }else{
            errorCode = errorMessage?.errorCode;
          }
   
          console.log(error)
          updateIncomplete = true;
          this._loader.endProcess();
        }
      );
      this.sub.add(nameEquipmentSub);
    }
    // multiple name edit
    else if (names.length > 0) {
      let equipmentResp;
      let connectedStrengthEquipmentResp;
      let smartInfraEquipmentResp;
      
      this._loader.startProcess();      
      this._amplitudeAnalytics.logEvent({elementName: 'Update Names', action: 'Submit'});
      const cardioEquipmentReqData = names.filter(val => val.equipmentType === 'cardio');
      if(cardioEquipmentReqData.length>0){
        try{
          equipmentResp = await this._equipmentService.nameAllEquipment(this.facilityId, cardioEquipmentReqData);
          this.nameAllUpdateSuccess(names);
        }catch(error){
          console.log(error);
          updateIncomplete = true;
        } 
      }
      const connectedStrengthEquipmentReqData = names.filter(val => val.equipmentType === 'strength');
      if(connectedStrengthEquipmentReqData.length>0){
        try{
          connectedStrengthEquipmentResp = await this._equipmentService.nameAllConnectedStrengthEquipment(this.facilityId, connectedStrengthEquipmentReqData);
          this.nameAllUpdateSuccess(names);
        
        }catch(error){
          console.log(error);
          updateIncomplete = true;
        } 
      }
      const smartInfraEquipmentReqData = names.filter(val => val.equipmentType === 'smartInfra');
      if(smartInfraEquipmentReqData.length>0){
        try{
          smartInfraEquipmentResp = await this._equipmentService.nameAllSmartInfraEquipment(this.facilityId, smartInfraEquipmentReqData);
          this.nameAllUpdateSuccess(names);
        
        }catch(error){
          console.log(error);
          updateIncomplete = true;
        } 
      }
      this._loader.endProcess();
      if (!updateIncomplete) {
        this._toast.creatToast(this.commonUtil.translateText('UPDATED.EQUIPMENT'));
      }
    }
    this.rootScopeData.isPageHasUnsavedChanges = updateIncomplete?true:false;
  }

  nameAllUpdateSuccess(names: INameAllEquipmentData[]) {
    names.map((n) => {
      this.originalList.map((group) => {
        if (group.assetDetails)
          group.assetDetails.map((asset) => {
            if (asset.id && asset.id == n.id) {
              asset.name = n.name;
            }
          });
      });
      this.originalNonCardioEquipmentList.map((group) => {
        if (group.nonCardioAssetDetailsObject)
          group.nonCardioAssetDetailsObject.map((asset) => {
            if(n.assetId){
              if(asset.assetId === n.assetId){
                asset.nickName = n.name;
              }
            }else{
              if (asset.equipmentSerialNumber && asset.equipmentSerialNumber.toString() == n.id.toString()) {
                asset.nickName = n.name;
              }
            }
            
          });
      });
    });

    // reset view
    this.showActionBtns = false;
    this.nameAllCancel();
  }

  nameChanged(newObj: any) {
    this.isNameModified = true;
    this.setDraftedFlag();
  }
  setDraftedFlag(): void {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }
  openUnsavedModal(): void {
    this.showUnsavedModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeUnsavedModal();
    this.rootScopeData.isPageHasUnsavedChanges = false;
    if (this.savedDeleteAssetData) {
      this.confirmDeleteAsset(this.savedDeleteAssetData.asset, this.savedDeleteAssetData.equipmentType, this.savedDeleteAssetData.ind);
      this.savedDeleteAssetData = null;
    }
  }

  openView(data: []): void {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.pathToNavigate = data;
      this.rootScopeData.showUnSavedChangesModal = true;
      return
    }
    this._router.navigate([data.join('/')]);
  }

  closeUnsavedModal(): void {
    this.showUnsavedModal = false;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
